module.exports = __webpack_public_path__ + "img/49.2a861a6c.jpg";